import { useField, useFormikContext } from "formik"

import { L2RCheckbox } from "../../components/L2RCheckbox"

export function FormikCheckbox(props) {
    const [fieldProps, metaProps] = useField(props)
    const { setStatus } = useFormikContext()

    const handleChange = (event, checked) => {
        fieldProps.onChange(event, checked)
        setStatus()
    }

    return (
        <L2RCheckbox {...fieldProps} {...props}
            label="Text on screen"
            type="checkbox"
            {...fieldProps}
            {...props}
            {...((metaProps.error && metaProps.touched) ? {
                error: true,
                helperText: metaProps.error,
            } : {})}
            onChange={handleChange}
        />
    )
}

FormikCheckbox.propTypes = L2RCheckbox.propTypes